<template>
  <div class="modal-overlay">
    <div class="modal-container">
      <h2 class="title">Онлайн трансляция</h2>
      <div class="tabs">
        <div
          v-for="tab in tabs"
          :key="tab.value"
          @click="activeTab = tab.value"
          class="tab"
          :class="{ active: activeTab === tab.value }"
        >
          {{ tab.label }}
          <span> (тікелей эфир)</span>
        </div>
      </div>
      <div class="video-container">
        <iframe
          :src="activeTabUrl"
          title="YouTube video player"
          frameborder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
          referrerpolicy="strict-origin-when-cross-origin"
          allowfullscreen
        ></iframe>
      </div>

      <button @click="closeModal" class="close-button">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
          <path
            d="M19 5L5 19M5 5L19 19"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
          />
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "LiveStreaming",
  data() {
    return {
      tabs: [
        {
          label: "Мекке",
          value: "mekke",
          url: "https://www.youtube.com/embed/2Gub8-cSH9c?si=iowA4Ty3ZxSDm_-s",
        },
        {
          label: "Медина",
          value: "medina",
          url: "https://www.youtube.com/embed/yWw0DWJQVtU?si=lVGV1KUz_YG_rE46",
        },
      ],
      activeTab: "mekke",
    };
  },
  computed: {
    activeTabUrl() {
      const activeTab = this.tabs.find((tab) => tab.value === this.activeTab);
      return activeTab ? activeTab.url : "";
    },
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="scss">
.modal-overlay {
  @apply fixed top-0 left-0 right-0 bottom-0 bg-black bg-opacity-50 flex justify-center items-center z-[1000];
}

.modal-container {
  @apply w-[90%] h-[50%] lg:h-[80%] max-h-[800px] max-w-[800px] bg-white rounded-2xl relative;
  @apply flex flex-col gap-3 p-3 pt-5 md:p-5 md:pt-8 md:gap-4;

  .title {
    @apply text-lg md:text-xl lg:text-2xl font-bold text-black m-0 leading-none;
  }

  .tabs {
    @apply flex bg-[#f1f1f1] p-1 rounded-xl w-full;
    .tab {
      @apply flex-1 p-2 rounded-lg text-center cursor-pointer;
      @apply text-[14px] text-black flex gap-x-1 items-center justify-center;

      &.active {
        @apply bg-[#fdc901];
      }

      span {
        @apply hidden md:block;
      }
    }
  }

  .video-container {
    @apply w-full h-full flex justify-center items-center bg-[#222] rounded-xl overflow-hidden;
    iframe {
      @apply w-full h-full;
    }
  }
}

.close-button {
  @apply absolute right-3 top-3 md:right-5 md:top-5 text-gray-400;
  @apply bg-transparent border-none cursor-pointer p-0;
  &:hover {
    @apply text-black;
  }
}
</style>
